export default __webpack_public_path__ + "static/media/photo--sm--namrata-4.cde4e829.jpg";